<header>
    <div class="container-width">

        <div class="header-left">
            <img (click)="openIntranet()" loading="eager" class="logo" src="/img/home.png">
            <img (click)="reloadPage()" loading="eager" class="logo" src="/Tridimo_logo_Web_Transparent-300dpi_2246x528.png" alt="Tridimo Logo">
        </div>
        <div class="dropdown" (click)="toggleDropdown($event)">
            <button class="btn btn-secondary">
              {{ userName }} <span>&#9662;</span>
            </button>
            <div *ngIf="isDropdownOpen" class="dropdown-menu">
                <a class="dropdown-item" (click)="openIntranet()">Intranet</a>
                <a class="dropdown-item" (click)="logout()">Logout</a>
            </div>
        </div>          
    </div>
</header>